import React, { useState, useEffect } from 'react';
import { toast } from 'react-toastify';
import { Box, IconButton, Table, TableBody, TableCell, TableHead, TableRow, Typography } from '@mui/material';
import { Delete, Edit } from '@mui/icons-material';
import ApiHelper from 'utils/apiHelper';
import DeleteConfirmationDialog from 'components/Management/DeleteConfirmationDialog';
import EditReportDeliveryDialog from './EditReportDeliveryDialog';

const DeliveryReportRule = () => {
    const [loading, setLoading] = useState(false);
    const [deliveryReportRulesData, setDeliveryReportRulesData] = useState([]);
    const [reportsData, setReportsData] = useState([]);
    const [usersData, setUsersData] = useState([]);
    const [showEditReportDeliveryRuleDialog, setShowEditReportDeliveryRuleDialog] = useState(false);
    const [showDeleteConfirmationDialog, setShowDeleteConfirmationDialog] = useState(false);
    const [selectedReportDeliveryRuleData, setSelectedReportDeliveryRuleData] = useState({});
    const [deletionRuleId, setDeletionRuleId] = useState(0);

    useEffect(() => {
        setLoading(true);
        getDeliveryReportRulesData();
    }, []);

    const getDeliveryReportRulesData = () => {
        if (localStorage.getItem('reports')) {
            localStorage.removeItem('reports');
        }
        if (localStorage.getItem('users')) {
            localStorage.removeItem('users');
        }
        ApiHelper.get(`/api/automation/delivery_reports/`)
            .then((res) => {
                setDeliveryReportRulesData(res.data.delivery_list);
                setReportsData(res.data.reports);
                setUsersData(res.data.users);
                localStorage.setItem('reports', JSON.stringify(res.data.reports));
                localStorage.setItem('users', JSON.stringify(res.data.users));
                setLoading(false);
            })
            .catch(() => {
                toast.error('Failed to get the delivery report rules data');
                setLoading(false);
            });
    };

    const handleEditDeliveryReportRule = (data) => {
        setShowEditReportDeliveryRuleDialog(true);
        setSelectedReportDeliveryRuleData(data);
    };

    const handleCloseEditReportDeliveryDialog = () => {
        setShowEditReportDeliveryRuleDialog(false);
        getDeliveryReportRulesData();
    };

    const handleDeleteConfirmation = (id) => {
        setShowDeleteConfirmationDialog(true);
        setDeletionRuleId(id);
    };

    const handleDeleteRule = () => {
        ApiHelper.delete(`/api/automation/delivery_reports/${deletionRuleId}/`)
            .then(() => {
                toast.success('Successfully deleted the delivery report rule');
                setShowDeleteConfirmationDialog(false);
                getDeliveryReportRulesData();
            })
            .catch(() => {
                toast.error('Failed to delete the delivery report rule');
            });
    };

    if (!deliveryReportRulesData) {
        return null;
    } else {
        return loading === true ? (
            <Typography sx={{ mt: 3, textAlign: 'center', fontSize: '16px', fontWeight: 'bold' }}>Please wait...</Typography>
        ) : deliveryReportRulesData.length === 0 ? (
            <Typography sx={{ mt: 3, textAlign: 'center' }}>No Delivery Report Rules Data</Typography>
        ) : (
            <Table sx={{ minWidth: 700 }}>
                <TableHead>
                    <TableRow>
                        <TableCell>Report to Deliver</TableCell>
                        <TableCell>Receiving User</TableCell>
                        <TableCell>Frequency</TableCell>
                        <TableCell>Delivery Date</TableCell>
                        <TableCell>Options</TableCell>
                    </TableRow>
                </TableHead>
                <TableBody>
                    {deliveryReportRulesData.map((data, key) => (
                        <TableRow key={key}>
                            <TableCell>{data.report_name}</TableCell>
                            <TableCell>{data.emails}</TableCell>
                            <TableCell>{`${data.frequency} ${data.freqtype}`}</TableCell>
                            <TableCell>{data.delivery_date}</TableCell>
                            <TableCell>
                                <Box>
                                    <IconButton size="small" onClick={() => handleEditDeliveryReportRule(data)}>
                                        <Edit fontSize="small" />
                                    </IconButton>
                                    <IconButton size="small" onClick={() => handleDeleteConfirmation(data.id)}>
                                        <Delete fontSize="small" />
                                    </IconButton>
                                </Box>
                            </TableCell>
                        </TableRow>
                    ))}
                    {showDeleteConfirmationDialog && (
                        <DeleteConfirmationDialog
                            name="report delivery rule"
                            onClose={() => setShowDeleteConfirmationDialog(false)}
                            onYes={handleDeleteRule}
                        />
                    )}
                    {showEditReportDeliveryRuleDialog && (
                        <EditReportDeliveryDialog
                            onClose={handleCloseEditReportDeliveryDialog}
                            onCloseCancel={() => setShowEditReportDeliveryRuleDialog(false)}
                            data={selectedReportDeliveryRuleData}
                            reportsData={reportsData}
                            usersData={usersData}
                        />
                    )}
                </TableBody>
            </Table>
        );
    }
};

export default DeliveryReportRule;
